module.exports = __webpack_public_path__ + "static/media/Ligue1_Logo.d0f5b276.svg";